import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setCurrentActiveTab } from "../../state/actions/LettersReportsActions";
import { useHistory } from "react-router";
import useDidMountEffect from "../../customHooks/useDidMountEffect";
import FilterbarChipsProps from "./FilterbarChipsProps";
import { Chip, Stack, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { SxProps } from "@mui/system";
import { isEnterPress } from "../../utils/helpers/accessibilityUtil";
import "./FilterbarChips.scss";

const getWindowsSize = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};

const FilterbarChips = (props: FilterbarChipsProps) => {
  const { t, i18n } = useTranslation("common");
  const dispatch = useDispatch();
  const history = useHistory();

  const createYearsData = (start: number): string[] => {
    const labelsArr = [t("DashboardRestOption.expandLastChip")];
    for (let i = start; i < new Date().getFullYear() - 6; i++) {
      labelsArr.unshift(i.toString());
    }
    return labelsArr;
  };

  let labels: string[] = createYearsData(2007);
  const [sizes] = useState(getWindowsSize());
  const [open, setOpen] = useState(false);
  const [currentExpandLabel, setCurrentExpandLabel] = useState<string>(
    t("DashboardRestOption.lastChipValue")
  );

  const handleClick = (label: string) => {
    if (label !== props.labelsArray[props.labelsArray.length - 1]) {
      setCurrentExpandLabel(label);
      props.setCurrentActive(label);
    }
    if (label === labels[labels.length - 1]) {
      dispatch(setCurrentActiveTab(t("LettersReports.TabLabel2")));
      // window.scrollTo(0, 0);
      history.push("/reports");
    }
    setOpen((prev) => !prev);
  };

  const handleClickAway = () => {
    setOpen(false);
  };

   /* itay turgeman
   * create dynamic function to add all years from 2005 until current year and descriment 6 years
   * function return new string array with all options
   */
  const getLabels = () => {
    if (sizes.width > 769) {
      return props.labelsArray;
    }
    const newLables = [
      props.labelsArray[0],
      props.labelsArray[props.labelsArray.length - 1],
    ];
    labels = [t("DashboardRestOption.expandLastChip")];
    for (let i = 2007; i <= new Date().getFullYear(); i++) {
      labels.unshift(i.toString());
    }

    return newLables;
  };

  useDidMountEffect(() => {
    if (sizes.width > 769) return; // only for mobile

    if (props.currentActive) {
      // handle mobile last filter result chip ui bug
      props.currentActive !== t("DashboardRestOption.firstChipValue") &&
        setCurrentExpandLabel(props.currentActive);
    }
  }, [props.currentActive]);

  useDidMountEffect(() => {
    setCurrentExpandLabel(t("DashboardRestOption.lastChipValue"));
  }, [i18n.language]);

  const styles: SxProps = {
    position: "absolute",
    top: 50,
    right: "-10px",
    left: 0,
    zIndex: 1,
    bgcolor: "#3F4244",
    width: "145px",
    borderRadius: "20px",
  };

  return (
    <>
      <Stack direction="row" spacing={props.spacing}>
        {getLabels().map((label: string, index: number) =>
          getLabels().length - 1 === index && props.fromDashboard ? (
            <ClickAwayListener onClickAway={handleClickAway} key={index}>
              <Box sx={{ position: "relative" }}>
                <Chip
                  onClick={() => handleClick(label)}
                  key={index}
                  className={"Chip-cu"}
                  label={currentExpandLabel}
                  aria-label={currentExpandLabel}               
                  icon={       
                   
                    !open ? (
                      <KeyboardArrowDownIcon
                      style={{ color:  props.isActive(currentExpandLabel) ? "#ffffff" : "#000000" }}                      
                      fontSize="small"   
                      className={"icon-chip"}                 
                     />                     
                    ) : (
                       <KeyboardArrowUpIcon
                       style={{ color:  props.isActive(currentExpandLabel) ? "#ffffff" : "#000000"}}    
                      className={"icon-chip"}
                           
                       fontSize="small"                       
                       />                       
                    )
                  }
                  sx={{
                    fontFamily: "Assistant",
                    fontSize: "18px",
                    borderRadius: "32px",
                    height: "40px",
                    background: `${
                      props.isActive(currentExpandLabel) ? "#0250C1" : "#F0F3F6"
                    }`,
                    cursor: "pointer",
                    marginLeft: "5px",
                    flexDirection: "row-reverse",
                    color: `${
                      props.isActive(currentExpandLabel) ? "#ffffff" : "#000000"
                    }`,
                    "&:hover": {
                      backgroundColor: "#0250C1",
                      color:"#ffffff"
                    },
                  
                  }}
                />
                {open ? (
                  <Box sx={styles}>
                    {labels.map((label: string, index: number) => (
                      <div
                        className="chips-more-years-label "
                        key={index}
                        onClick={() => handleClick(label)}
                        onKeyPress={(event) =>
                          isEnterPress(event) && handleClick(label)
                        }
                        tabIndex={0}
                      >
                        {label}
                      </div>
                    ))}
                  </Box>
                ) : null}
              </Box>
            </ClickAwayListener>
          ) : (
            <Chip
              onClick={() => props.setCurrentActive(label)}
              key={index}
              label={label}
              aria-pressed={ props.isActive(label) ? true : false}   
              sx={{
                fontFamily: "Assistant",
                fontSize: "18px",
                borderRadius: "32px",
                height: "40px",
                background: `${props.isActive(label) ? "#0250C1" : "#F0F3F6"}`,
                cursor: "pointer",
                marginLeft: "5px",
                "&:hover": {
                  backgroundColor: "#0250C1",
                  color:"#ffffff"
                },
                color:`${props.isActive(label) ? "#ffffff" : "#000000"}`
              }}
            />
          )
        )}
      </Stack>
    </>
  );
};

export default FilterbarChips;
